import { render, staticRenderFns } from "./corporateInformation.vue?vue&type=template&id=5011f5ce&scoped=true"
import script from "./corporateInformation.vue?vue&type=script&lang=js"
export * from "./corporateInformation.vue?vue&type=script&lang=js"
import style0 from "./corporateInformation.vue?vue&type=style&index=0&id=5011f5ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5011f5ce",
  null
  
)

export default component.exports